import { render, staticRenderFns } from "./CreateAddress.vue?vue&type=template&id=18ac88a2&scoped=true&"
import script from "./CreateAddress.vue?vue&type=script&lang=js&"
export * from "./CreateAddress.vue?vue&type=script&lang=js&"
import style0 from "./CreateAddress.vue?vue&type=style&index=0&id=18ac88a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ac88a2",
  null
  
)

export default component.exports